import { initWidgets } from "tsi-common-react/src/forms/initWidgets";

initWidgets();
